import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { PROCESS_STEPS } from "../../data/site";

export default function Process() {
    const listRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: listRef,
        offset: ["start 0.75", "end 0.55"],
    });

    return (
        <section data-testid="process-section" className="relative border-t border-slate-200 bg-white py-24 sm:py-32">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-4 sm:px-8 lg:grid-cols-12 lg:px-16">
                <div className="lg:col-span-5">
                    <div className="lg:sticky lg:top-32">
                        <Reveal>
                            <Eyebrow testId="process-eyebrow">Process</Eyebrow>
                            <h2 className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
                                How we work
                            </h2>
                            <p className="mt-6 max-w-md text-base leading-relaxed text-slate-600 sm:text-lg">
                                A clear, deliberate path from first conversation to a product
                                in the hands of real users.
                            </p>
                        </Reveal>
                    </div>
                </div>

                <div ref={listRef} className="relative lg:col-span-7">
                    <div className="absolute bottom-2 left-[7px] top-2 w-px bg-brand/15" aria-hidden="true" />
                    <motion.div
                        style={{ scaleY: scrollYProgress }}
                        className="absolute bottom-2 left-[7px] top-2 w-px origin-top bg-brand"
                        aria-hidden="true"
                    />
                    <ol className="space-y-14">
                        {PROCESS_STEPS.map((step, i) => (
                            <Reveal key={step.num} delay={i * 0.05} y={24}>
                                <li data-testid={`process-step-${step.num}`} className="relative pl-12">
                                    <span
                                        className="absolute left-0 top-1.5 flex h-[15px] w-[15px] items-center justify-center rounded-full border-2 border-brand/50 bg-white"
                                        aria-hidden="true"
                                    >
                                        <span className="h-[5px] w-[5px] rounded-full bg-brand" />
                                    </span>
                                    <span className="font-mono text-xs font-semibold tracking-[0.25em] text-brand">
                                        {step.num}
                                    </span>
                                    <h3 className="mt-2 font-display text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
                                        {step.title}
                                    </h3>
                                    <p className="mt-2 max-w-lg text-sm leading-relaxed text-slate-600 sm:text-base">
                                        {step.desc}
                                    </p>
                                </li>
                            </Reveal>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
}
